var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSrkInfraIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 13.3333H3.33333V6.66667H13.3333V13.3333H15V4.45833L8.33333 1.79167L1.66667 4.45833V13.3333ZM0 15V3.33333L8.33333 0L16.6667 3.33333V15H11.6667V8.33333H5V15H0ZM5.83333 15V13.3333H7.5V15H5.83333ZM7.5 12.5V10.8333H9.16667V12.5H7.5ZM9.16667 15V13.3333H10.8333V15H9.16667ZM3.33333 6.66667H8.33333H13.3333H3.33333Z",
    fill: "#1D3B5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrkInfraIcon);
export default __webpack_public_path__ + "static/media/srkInfraIcon.3d05f8ddad8c9bf1a9411e1bfbad9015.svg";
export { ForwardRef as ReactComponent };